import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <svg
    className={className}
    aria-hidden="true"
    focusable="false"
    role="img"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M51.5 13A37.54 37.54 0 0 1 89 50.5 37.5 37.5 0 1 1 51.5 13zm0 6.25a31.249 31.249 0 0 0-22.097 53.347A31.249 31.249 0 0 0 51.5 81.75a31.29 31.29 0 0 0 22.087-9.163A31.29 31.29 0 0 0 82.75 50.5 31.249 31.249 0 0 0 51.5 19.25zm8.688 12.595a3.131 3.131 0 0 1 2.366.351 3.13 3.13 0 0 1 1.071 4.289l-18.75 31.25a3.125 3.125 0 1 1-5.359-3.217l18.75-31.25a3.122 3.122 0 0 1 1.922-1.423zm8.322 16.04a9.387 9.387 0 0 1 9.376 9.376 9.376 9.376 0 1 1-9.375-9.375zm1.196 6.49a3.124 3.124 0 1 0-2.39 5.772 3.124 3.124 0 0 0 2.39-5.773zM34.491 34.49a9.38 9.38 0 0 1 9.373 9.378 9.386 9.386 0 0 1-9.375 9.372 9.378 9.378 0 0 1-9.375-9.375 9.376 9.376 0 0 1 9.377-9.375zm1.195 6.489a3.128 3.128 0 0 0-3.406.676 3.125 3.125 0 0 0 2.21 5.335l.176-.005a3.127 3.127 0 0 0 2.948-3.117c0-1.264-.76-2.405-1.928-2.89z" fill="currentColor" />
  </svg>
))``;
